export enum ComparisonPills {
    FULLY_BUILT = 'rigid',
    FLATPACK = 'flatpack'
};
